export const getDefaultOptions = (moduleMetadata) => {
  return JSON.parse(JSON.stringify(moduleMetadata?.default_options || {}));
};

export const buildDraftFromMetadata = (moduleMetadata, config = null) => ({
  module: config?.module || moduleMetadata?.module || '',
  discriminant_id: config?.discriminant_id || '',
  options: JSON.parse(JSON.stringify(config?.options || getDefaultOptions(moduleMetadata))),
  advancedMode: false,
  advancedOptionsText: JSON.stringify(config?.options || getDefaultOptions(moduleMetadata), null, 2)
});

export const formatDateTime = (value) => {
  if (!value) return '-';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString();
};

export const countUpdatedToday = (configs) => {
  const today = new Date().toDateString();
  return configs.filter((config) => {
    const date = new Date(config.updated_at);
    return !Number.isNaN(date.getTime()) && date.toDateString() === today;
  }).length;
};

export const countEnabledFeatures = (configs) => {
  return configs.reduce((total, config) => {
    const options = config?.options || {};
    return total + Object.entries(options)
      .filter(([key, value]) => key !== 'admin_only' && value === true)
      .length;
  }, 0);
};

export const getOptionsSummary = (config) => {
  const adminOnlyFlags = config?.options?.admin_only || [];
  const enabledToggles = Object.entries(config?.options || {})
    .filter(([key, value]) => key !== 'admin_only' && value === true)
    .map(([key]) => key.replaceAll('_', ' '));

  if (adminOnlyFlags.length > 0) {
    return {
      tone: 'purple',
      title: `${adminOnlyFlags.length} admin-only rule${adminOnlyFlags.length > 1 ? 's' : ''}`,
      details: adminOnlyFlags.map((flag) => flag.replaceAll('_', ' '))
    };
  }

  if (enabledToggles.length > 0) {
    return {
      tone: 'green',
      title: `${enabledToggles.length} enabled option${enabledToggles.length > 1 ? 's' : ''}`,
      details: enabledToggles
    };
  }

  return {
    tone: 'gray',
    title: 'No active restriction',
    details: ['Visible for standard users']
  };
};

export const getToneClasses = (tone) => {
  const tones = {
    purple: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-200 dark:border-purple-800',
    blue: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-200 dark:border-blue-800',
    green: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200 dark:border-emerald-800',
    gray: 'bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700'
  };

  return tones[tone] || tones.gray;
};
